/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../orchestration/responsive.directive';
import * as import3 from '../../orchestration/responsive.service';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from '../../html-utils/element-width.directive';
import * as import6 from './menu-subcategory-anchor-panel.component';
import * as import7 from '../menu.model';
const styles_MenuSubcategoryAnchorPanelComponent:any[] = ([] as any[]);
export const RenderType_MenuSubcategoryAnchorPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MenuSubcategoryAnchorPanelComponent,
  data: {}
}
);
function View_MenuSubcategoryAnchorPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        2,
        0
      ]
      ,
      [
        'anchor',
        1
      ]

    ]
      ,(null as any),6,'div',[[
        'class',
        'menu-anchorbar-scroller-content-anchor'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'menu-anchorbar-scroller-content-anchor-name'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.menuModel.selectAnchor(v.context.index,false,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['selected']),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'menu-anchorbar-scroller-content-anchor-name';
    const currVal_1:any = ck(v,4,0,(v.context.index === co.menuModel.selectedAnchorIndex));
    ck(v,3,0,currVal_0,currVal_1);
  },(ck,v) => {
    const currVal_2:any = v.context.$implicit;
    ck(v,5,0,currVal_2);
  });
}
function View_MenuSubcategoryAnchorPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[
      [
        'class',
        'menu-anchorbar'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-item-images']),
    import0.ɵdid(737280,(null as any),0,import2.ResponsiveDirective,[
      import0.ElementRef,
      import3.ResponsiveService,
      import4.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'scroller',
        1
      ]

    ]
    ,(null as any),10,'div',[
      [
        'class',
        'menu-anchorbar-scroller'
      ]
      ,
      [
        'woa-element-width',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'scroll'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('scroll' === en)) {
        const pd_0:any = ((<any>co.scrolling$.next()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['scrolled']),
    import0.ɵdid(5455872,(null as any),0,import5.ElementWidthDirective,[
      import0.ElementRef,
      import0.ChangeDetectorRef,
      import3.ResponsiveService
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'menu-anchorbar-scroller-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuSubcategoryAnchorPanelComponent_2)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'menu-anchorbar';
    const currVal_1:any = ck(v,2,0,co.menuModel.showItemImages);
    ck(v,1,0,currVal_0,currVal_1);
    ck(v,3,0);
    const currVal_2:any = 'menu-anchorbar-scroller';
    const currVal_3:any = ck(v,7,0,import0.ɵnov(v,5).scrollLeft);
    ck(v,6,0,currVal_2,currVal_3);
    ck(v,8,0);
    const currVal_4:any = co.menuModel.selectedCategoryAnchorNames;
    ck(v,13,0,currVal_4);
  },(null as any));
}
export function View_MenuSubcategoryAnchorPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(671088640,1,{scroller: 0}),
    import0.ɵqud(671088640,2,{anchors: 1}),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuSubcategoryAnchorPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import6.MenuSubcategoryAnchorPanelComponent = v.component;
    const currVal_0:any = (co.menuModel.selectedCategoryAnchorNames.length > 1);
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_MenuSubcategoryAnchorPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-subcategory-anchor-panel',([] as any[]),(null as any),(null as any),(null as any),View_MenuSubcategoryAnchorPanelComponent_0,RenderType_MenuSubcategoryAnchorPanelComponent)),
    import0.ɵdid(4440064,(null as any),0,import6.MenuSubcategoryAnchorPanelComponent,[
      import7.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const MenuSubcategoryAnchorPanelComponentNgFactory:import0.ComponentFactory<import6.MenuSubcategoryAnchorPanelComponent> = import0.ɵccf('woa-menu-subcategory-anchor-panel',import6.MenuSubcategoryAnchorPanelComponent,View_MenuSubcategoryAnchorPanelComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/menu/menu-subcategory-anchor-panel/menu-subcategory-anchor-panel.component.ngfactory.ts